import { Component } from "react";
import contactStyle from './contact.module.css';
import Headquarters from "./headquarters/headquarters";

class Contact extends Component {
    title = 'Contact us';

    contactUs() {
        return (
            <div className={`${contactStyle.bg_greeny_grey} ${contactStyle.noise} ${contactStyle.pb_6r} d-flex justify-content-center py-5 text-light`}>
                <div className={`${contactStyle.bg} d-flex`}>
                    <div className={`${contactStyle.bg} container`}>
                        <div className={`${contactStyle.padding_mobile}`}>
                            <h3 class="mt-5 fs-4 text-uppercase">Mr-Draft, Family Owned and Operated</h3>
                            <h1 class="display-2 fw-bolder text-capitalize">{this.title}</h1>
                            <div class="row mt-5">
                                <div className={`col-sm-5 col-md-6 ${contactStyle.max_w_800}`}>
                                    <form class="text-start">
                                        <div class="form-group">
                                            <label htmlFor="email">Name</label>
                                            <input type="text" class="form-control modern-input" id="name" aria-describedby="nameHelp" placeholder="Name" required />
                                            {/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                        </div>
                                        <div class="form-group mt-2">
                                            <label htmlFor="phone">Phone</label>
                                            <input type="phome" class="form-control modern-input" id="phone" placeholder="Phone" required />
                                        </div>
                                        <div class="form-group mt-2">
                                            <label htmlFor="location">Location</label>
                                            <input type="text" class="form-control modern-input" id="location" placeholder="Location" required />
                                        </div>
                                        <div class="form-group mt-2">
                                            <label htmlFor="message">Message</label>
                                            <textarea class="form-control modern-input" id="message" rows="3" placeholder="Explain us your problem" required></textarea>
                                        </div>
                                        <button type="submit" class="btn btn-warning w-100 mt-3 py-2 text-light">Submit</button>
                                    </form>
                                </div>
                                <div className={`col-sm-5 col-md-6 text-start d-flex ${contactStyle.max_w_800} ${contactStyle.contact_description_mobile}`}>
                                    <div class="d-block m-auto">
                                        <p className={`fs-5 lh-sm`}>
                                            Cheers to clean beer! Contact Mr-Draft today for a reliable and thorough beer line cleaning service in New York City. Our team will ensure your beer stays fresh and delicious for your customers to enjoy.
                                        </p>
                                        <ul class="list-group list-group-flush align-items-start fs-5">
                                            <li className={`list-group-item text-light ${contactStyle.bg_transparent}`}>
                                                <a class="nav-link" href="tel:3476666818">
                                                    <i class="fa-solid fa-phone"></i>
                                                    <span class="ms-2">(347)-666-6818</span>
                                                </a>
                                            </li>
                                            <li className={`list-group-item text-light ${contactStyle.bg_transparent}`}>
                                                <a class="nav-link" href="mailto:1mrdraft@gmail.com">
                                                    <i class="fa-solid fa-envelope"></i>
                                                    <span class="ms-2">1mrdraft@gmail.com</span>
                                                </a>
                                            </li>
                                            <li className={`list-group-item text-light ${contactStyle.bg_transparent}`}>
                                                <a class="nav-link" href="/">
                                                    <i class="fa-solid fa-clock"></i>
                                                    <span class="ms-2">24/7</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        return (
            <>
                <section class="mt-navbar border-bottom">
                    {this.contactUs()}
                </section>
                <section className={`py-5 light-bg ${contactStyle.headquarters_container}`}>
                    <Headquarters />
                </section>
            </>
        );
    }
}

export default Contact;